import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, TextField, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import BlockIcon from "@mui/icons-material/Block";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  StyledWrapper,
  StyledTitle,
  ButtonContainer,
  StyledTextField,
  StyledImageTitle,
} from "./UserProfile.style";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import SalesCard from "components/shared/SalesCard";
import TableCM from "components/shared/Table";
import DatePickerCM from "components/shared/DatePicker";
import PopperCM from "components/shared/Popper";
import FilterBox from "components/shared/FilterBox";
import SelectBox from "components/shared/SelectBox";
import GenarateHeadCell from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import {
  blockUserRequest,
  getOrdersRequest,
  getProductsRequest,
  getProductStatsRequest,
  getUserInfoRequest,
  unBlockUserRequest,
  updateUserRequest,
  getUserAddressRequest,
} from "api/requests";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import { editUserSchema, validateImg } from "validations";
import PaginationCM from "components/shared/Pagination";
import Modal from "components/shared/Modal/Block";
import { PAGINATION_LIMIT } from "constants";
import spliter from "helper/digit-spliter";
import useFilter from "hooks/use-filter";
import ProgressBarCM from "components/shared/ProgressBar";
import Upload from "components/shared/Upload";

const headCells = GenarateHeadCell("userProfile");
const headCellsAddress = GenarateHeadCell("userAddress");
let initialPage = 1;

////////////////////////////
const formList = [
  {
    label: "نام",
    type: "text",
    id: "full_name",
    required: true,
  },
  {
    label: "تلفن همراه",
    type: "tel",
    id: "phone_number",
    required: true,
  },
  {
    label: "ایمیل",
    type: "email",
    id: "email",
  },
  { label: "رمز عبور", type: "text", id: "password" },

  // { label: "استان", type: "text", id: "state" },
  // { label: "شهر", type: "text", id: "city" },
  // {
  //   label: "کد پستی",
  //   type: "tel",
  //   id: "postal_code",
  // },
  // { label: "آدرس", type: "tel", id: "address" },
];

export default function UserProfile() {
  const navigate = useNavigate();
  const params = useParams();
  const filterCTX = useFilter("factor");
  const {
    request,
    loading,
    isUploading,
    setLoading,
    setUploadProgress,
    uploadProgress,
  } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editUserSchema),
  });

  const [address, setAddress] = useState({ data: [], count: 0 });
  const [orders, setOrders] = useState({ count: 0, data: [] });
  const [salesCard, setSalesCard] = useState([]);
  const [page, setPage] = useState(initialPage);
  const [products, setProducts] = useState([]);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [datePoper, setDatePoper] = useState({ open: false, anchorEl: null });
  const [breadPoper, setBreadPoper] = useState({ open: false, anchorEl: null });
  const [active_card_number, setactive_card_number] = useState({
    url: null,
    isChanged: false,
  });
  const [business_license, setbusiness_license] = useState({
    url: null,
    isChanged: false,
  });
  const [rose_head_panel, setrose_head_panel] = useState({
    url: null,
    isChanged: false,
  });
  const [national_card, setnational_card] = useState({
    url: null,
    isChanged: false,
  });
  const [first_page_of_birth_certificate, setfirst_page_of_birth_certificate] =
    useState({
      url: null,
      isChanged: false,
    });

  const handleBlockModal = () => setShowBlockModal((state) => !state);

  const onBlockUser = async (values) => {
    if (getValues("is_blocked")) {
      const res = await request({
        url: unBlockUserRequest,
        values: params.colleagueId,
      });

      if (res) {
        Toast({
          type: "success",
          title: "رفع مسدودیت کاربر",
        });
      }
    } else {
      handleBlockModal();

      if (values.message.trim() === "")
        return Toast({ type: "empty", title: " دلیل مسدود سازی " });

      const res = await request({
        url: blockUserRequest,
        values: { id: params.colleagueId, message: values.message },
      });

      if (res) {
        Toast({
          type: "success",
          title: "مسدودیت کاربر",
        });
      }
    }
    getUserInfo();
  };

  ///////////////// handle image ////////////////
  const handleChangeImageactive_card_number = (val) => {
    validateImg(val);
    setactive_card_number({ url: val, isChanged: true });
  };
  const handleChangeImagebusiness_license = (val) => {
    validateImg(val);
    setbusiness_license({ url: val, isChanged: true });
  };
  const handleChangeImagerose_head_panel = (val) => {
    validateImg(val);
    setrose_head_panel({ url: val, isChanged: true });
  };
  const handleChangeImagenational_card = (val) => {
    validateImg(val);
    setnational_card({ url: val, isChanged: true });
  };
  const handleChangeImagefirst_page_of_birth_certificate = (val) => {
    validateImg(val);
    setfirst_page_of_birth_certificate({ url: val, isChanged: true });
  };

  const handelSearch = (e) => getOrders(e);

  const getOrders = async (search) => {
    setLoading(true);
    await getUserInfo();
    const orderRes = await request({
      url: getOrdersRequest,
      values: {
        skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: search ? 100 : PAGINATION_LIMIT,
        search,
        userId: params.colleagueId,
      },
      isMulty: true,
    });

    setLoading(false);

    if (orderRes) {
      if (orderRes.count < 1) {
        return setOrders({
          count: orderRes.count,
          data: [{ content: "هیچ سفارشی یافت نشد" }],
        });
      }
      const transormedOrderData = orderRes.data.map((items) => ({
        id: items.id,
        orderId: items.order_number,
        payment_status: items.payment_status == "failed" ? "ناموفق" : "موفق",
        date: items.created_at?.jdate.split(" ")[0],
        totalPrice: spliter(items.total_price),
      }));

      setOrders({ count: orderRes.count, data: transormedOrderData });
    }
  };

  const getAddress = useCallback(async () => {
    setLoading(true);
    await getUserInfo();
    const res = await request({
      url: getUserAddressRequest,
      values: {
        userId: params.colleagueId,
      },
    });

    // setLoading(false);
    if (res) {
      if (res.count < 1) {
        return setAddress({
          count: res.count,
          data: [{ content: "هیچ آدرسی یافت نشد" }],
        });
      }
      let transformedData = res.data.map((items) => ({
        id: items.id,
        address: items?.address,
        state: items?.state,
        city: items?.city,
        postal_code: items?.postal_code,
      }));

      setAddress({ data: transformedData, count: res.count });
    }
  }, [page, request]);

  const getUserInfo = useCallback(async () => {
    let res = await request({
      url: getUserInfoRequest,
      values: params.colleagueId,
      isMulty: true,
    });
    // setLoading(false);

    if (res) {
      reset({
        full_name: res.full_name,
        phone_number: res.phone_number,
        email: res.email,
        state: res.state,
        city: res.city,
        postal_code: res.postal_code,
        address: res.address,
        is_blocked: res.is_blocked,
      });
      setactive_card_number({ url: res.active_card_number, isWeb: true });
      setbusiness_license({ url: res.business_license, isWeb: true });
      setrose_head_panel({ url: res.rose_head_panel, isWeb: true });
      setnational_card({ url: res.national_card, isWeb: true });
      setfirst_page_of_birth_certificate({
        url: res.first_page_of_birth_certificate,
        isWeb: true,
      });
    }
  }, [request, params.colleagueId, reset]);

  useEffect(() => {
    getUserInfo();
    getOrders();
    getAddress();
  }, [getUserInfo]);

  //////////////// FORM ////////////////
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateUserRequest(
          {
            id: params.colleagueId,
            active_card_number,
            business_license,
            rose_head_panel,
            national_card,
            first_page_of_birth_certificate,
            ...data,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش کاربر",
      });
      getUserInfo();
    }
  };

  return (
    <DrawerCM title="مشخصات کاربر" onSearch={handelSearch}>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container spacing={1}>
          <Grid item mt={3}>
            <BackButton />
          </Grid>

          <Grid item mb={3} xs={12}>
            <StyledWrapper>
              <StyledTitle>ویرایش کاربر</StyledTitle>
              <Grid container>
                {/* <Grid
                  item
                  md={6}
                  xs={12}
                  p={1.5}
                  style={{ display: "none !important" }}
                >
                  <TextField
                    id={"type"}
                    label={"نوع کاربر"}
                    variant="outlined"
                    required
                    fullWidth
                    value={"colleague"}
                    {...register("type")}
                    error={Boolean(errors.type)}
                    helperText={errors.type?.message}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid> */}
                {formList.map((items, index) => (
                  <Grid
                    item
                    // md={formList.length - 1 === index ? 12 : 6}
                    md={6}
                    xs={12}
                    p={1.5}
                    key={"profile" + index}
                  >
                    <TextField
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      {...register(items.id)}
                      disabled={items.disabled}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                      InputProps={{
                        readOnly: items.readOnly,
                      }}
                    />
                  </Grid>
                ))}

                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>شماره حساب فعال</StyledImageTitle>
                  {active_card_number.url ? (
                    <Upload
                      isLocal={active_card_number.isChanged}
                      file={active_card_number.url}
                      isWeb={active_card_number.isWeb}
                      refillable
                      type="active_card_number"
                      onChange={handleChangeImageactive_card_number}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={active_card_number.isChanged}
                      file={active_card_number.url}
                      refillable
                      type="active_card_number"
                      onChange={handleChangeImageactive_card_number}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>جواز کسب</StyledImageTitle>
                  {business_license.url ? (
                    <Upload
                      isLocal={business_license.isChanged}
                      file={business_license.url}
                      isWeb={business_license.isWeb}
                      refillable
                      type="business_license"
                      onChange={handleChangeImagebusiness_license}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={business_license.isChanged}
                      file={business_license.url}
                      refillable
                      type="business_license"
                      onChange={handleChangeImagebusiness_license}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>تابلو سر در</StyledImageTitle>
                  {rose_head_panel.url ? (
                    <Upload
                      isLocal={rose_head_panel.isChanged}
                      file={rose_head_panel.url}
                      isWeb={rose_head_panel.isWeb}
                      refillable
                      type="rose_head_panel"
                      onChange={handleChangeImagerose_head_panel}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={rose_head_panel.isChanged}
                      file={rose_head_panel.url}
                      refillable
                      type="rose_head_panel"
                      onChange={handleChangeImagerose_head_panel}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>کارت ملی</StyledImageTitle>
                  {national_card.url ? (
                    <Upload
                      isLocal={national_card.isChanged}
                      file={national_card.url}
                      isWeb={national_card.isWeb}
                      refillable
                      type="national_card"
                      onChange={handleChangeImagenational_card}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={national_card.isChanged}
                      file={national_card.url}
                      refillable
                      type="national_card"
                      onChange={handleChangeImagenational_card}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>صفحه اول شناسنامه</StyledImageTitle>
                  {first_page_of_birth_certificate.url ? (
                    <Upload
                      isLocal={first_page_of_birth_certificate.isChanged}
                      file={first_page_of_birth_certificate.url}
                      isWeb={first_page_of_birth_certificate.isWeb}
                      refillable
                      type="first_page_of_birth_certificate"
                      onChange={
                        handleChangeImagefirst_page_of_birth_certificate
                      }
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={first_page_of_birth_certificate.isChanged}
                      file={first_page_of_birth_certificate.url}
                      refillable
                      type="first_page_of_birth_certificate"
                      onChange={
                        handleChangeImagefirst_page_of_birth_certificate
                      }
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>

                <ButtonContainer>
                  <Button
                    color="warning"
                    startIcon={<BlockIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={
                      getValues("is_blocked") ? onBlockUser : handleBlockModal
                    }
                  >
                    {getValues("is_blocked") ? "رفع مسدودیت" : "مسدود کردن"}
                  </Button>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ویرایش
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledWrapper>
          </Grid>

          <Modal
            show={showBlockModal}
            onClose={handleBlockModal}
            title="مسدود کردن کاربر"
          >
            <StyledTextField
              id="message"
              label="دلیل مسدود سازی"
              variant="outlined"
              fullWidth
              multiline
              required
              rows={4}
              {...register("message")}
            />
            <ButtonContainer Tcenter>
              <Button
                startIcon={<BlockIcon />}
                variant="contained"
                sx={{ mt: 1 }}
                onClick={handleSubmit(onBlockUser)}
                color="warning"
              >
                مسدود کردن
              </Button>
            </ButtonContainer>
          </Modal>

          <Grid item xs={12} my={2}>
            <TableCM
              title="سفارشات کاربر"
              rows={orders.data}
              headCells={headCells}
              click={(orderId) => navigate("/orders/" + orderId)}
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => {
              initialPage = val;
              setPage(val);
            }}
            page={page}
            count={orders.count}
          />

          <Grid item xs={12} my={2}>
            <TableCM
              title="آدرس های کاربر"
              rows={address.data}
              headCells={headCellsAddress}
              click={(addressId) => navigate("/address/" + addressId)}
              page={page}
            />
          </Grid>
        </Grid>
      )}
    </DrawerCM>
  );
}
